import * as graphql from '@treams/treams-network';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'clientID') {
		return {
			title: 'Client ID',
			description: 'Vul de Client ID in die je van Visma hebt ontvangen.',
		};
	}

	if (key === 'tenantID') {
		return {
			title: 'Tenant ID',
			description: 'Vul de Tenant ID in die je van Visma hebt ontvangen.',
		};
	}

	if (key === 'secret') {
		return {
			title: 'Client Secret',
			description: 'Vul de Client Secret in die je van Visma hebt ontvangen.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

export default function VismaHRM() {
	return (
		<ProductLayout
			id="vismahrm"
			type={graphql.ConnectorType.Vismahrm}
			headerImageURL="https://assets.ontreams.com/marketplace/vismahrm-wide.jpg"
			translate={translate}
			price={125}
		/>
	);
}

export function VismaHRMTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="vismahrm"
			title="Visma.net HRM"
			description="Volledige cloud oplossing voor HRM."
			logoImageURL="https://assets.ontreams.com/marketplace/vismahrm.png"
			selected={props.selected}
			price={125}
		/>
	);
}
